export class AgeFilter {
  page = 0;
  pageSize = 20;
  dealerNumber: string = null;
  orderBy: string;
  order = 'ASC';
  ageGroup1: number[] = [0, 2];
  ageGroup2: number[] = [2, 5];
  ageGroup3: number[] = [5, 10];
  fromDate: Date;
  toDate: Date;
  dealerName: string = null;
  contractTypeId: number = null;
}
